// getters
const inventoryReports = state => state.inventoryReports

export default {
  inventoryReports
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/reports/getters.js